import React, { useState, useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import { Base64, toBase64 } from 'js-base64'
import usePersistedState from '../../hooks/usePersistedState'

import Button from '../../components/Button'
import Header from '../../components/Header'

import {
  UserData,
  ConfigData,
  ErroProps,
  UserDetails,
} from '../../utils/interfaces'
import { Container, Content, BtnVoltar } from './styles'
import api from '../../services/api'
import ModalBox from '../../components/Modal'

const InvestorQuiz: React.FC = () => {
  const [configData] = usePersistedState<ConfigData>(
    'configData',
    {} as ConfigData,
  )
  const [userData] = usePersistedState<UserData>('userData', {} as UserData)
  const [userDetails, setUserDetails] = usePersistedState<UserDetails>(
    'userDetails',
    {} as UserDetails,
  )

  const [, setErroProps] = usePersistedState<ErroProps>(
    'erroProps',
    {} as ErroProps,
  )
  const [selectedQuiz, setSelectedQuiz] = usePersistedState<string>(
    'selectedQuiz',
    '',
  )
  const [dcrSelectedQuiz, setDcrSelectedQuiz] = usePersistedState<string>(
    'dcrSelectedQuiz',
    '',
  )

  const [warningText, setWarningText] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const history = useHistory()

  const dcrCliente =
    configData.codCliente === 2004 ? 'PrevCummins' : 'HMG_PrevCummins'

  // const [urlInv] = useState(
  //   `http://192.1.0.52:8049/webrunstudio/form.jsp?sys=AUT&formID=464569691&cpf=${toBase64(
  //     userData.cpf.replaceAll('.', '').replaceAll('-', ''),
  //   )}=&cliente=${toBase64(dcrCliente)}`,
  // )

  // const [urlInv] = useState(
  //   `https://portal.universalprev.com.br/openform.do?sys=AUT&action=openform&formID=464569691&cpf=${toBase64(
  //     userData.cpf.replaceAll('.', '').replaceAll('-', ''),
  //   )}=&cliente=${toBase64(dcrCliente)}`,
  // )
  const [urlInv] = useState(
    `http://efpc.universalprev.com.br/openform.do?sys=AUT&action=openform&formID=464569691&cpf=${toBase64(
      userData.cpf.replaceAll('.', '').replaceAll('-', ''),
    )}=&cliente=${toBase64(dcrCliente)}`,
  )
  const handleContinue = useCallback(async () => {
    const parametros = Base64.encode(
      `{"token": "${configData.token}",
        "cliente":"${configData.codCliente}",
        "cpf":"${userData.cpf.replaceAll('.', '').replace('-', '')}"}`,
    )

    const parametrosFinal = Base64.encode(parametros)
    let perfil = ''
    await api
      .get(`wsChecaAvaliacaoPerfil.rule?sys=ADZ&Entrada=${parametrosFinal}`)
      .then(res => {
        if (res.data.tipoPerfil === 2) {
          perfil = 'CON'
          setDcrSelectedQuiz('conservador')
        } else if (res.data.tipoPerfil === 3) {
          perfil = 'MOD'
          setDcrSelectedQuiz('moderado')
        } else if (res.data.tipoPerfil === 4) {
          perfil = 'AGR'
          setDcrSelectedQuiz('agressivo')
        }
        setUserDetails({
          ...userDetails,
          investor: perfil,
        })
        setSelectedQuiz(perfil)
        history.push('/investor')
      })
      .catch(res => {
        if (res.message === 'Network Error') {
          setErroProps({
            title: res.message,
            description: 'Falha na conexão como servidor',
          })
          history.push('/erro')
        } else if (res.message === 'Request failed with status code 500') {
          setErroProps({
            title: 'Erro interno no servidor',
            description: res.message,
          })
          history.push('/erro')
        } else if (res.message === 'Request failed with status code 401') {
          setIsModalOpen(true)
          setWarningText('Você precisa responder o questionário para avaçar.')
        } else if (res.message === 'Request failed with status code 408') {
          alert('Tempo de sessão expirado')
          history.push('/register')
        } else {
          setIsModalOpen(true)
          setWarningText('Ops, algo deu errado. Tente novamente mais tarde.')
        }
      })
  }, [configData, history, setErroProps, setUserDetails, userData, userDetails])

  function handleCloseModal(): void {
    setIsModalOpen(false)
  }

  return (
    <>
      <Header />
      <Container>
        <Content>
          {/* <strong>Perfil de Investidor</strong> */}
          <iframe src={`${urlInv}`} title="Perfil Investidor" />
        </Content>
        <Button type="button" color="orange" onClick={handleContinue}>
          Continuar
        </Button>
        <BtnVoltar type="button" onClick={() => history.push('/taxation')}>
          &lt; Anterior
        </BtnVoltar>
        <ModalBox isOpen={isModalOpen} onRequestClose={handleCloseModal}>
          <p>{warningText}</p>
        </ModalBox>
      </Container>
    </>
  )
}

export default InvestorQuiz
